import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGSharedModule } from '@shared/prime/prime-ng.module';
import { SessionService } from '@core/services/session/session.service';
import { Subscription } from 'rxjs';
import { SESSION_CONSTANTS } from '@core/constants';

@Component({
  selector: 'app-session-warning-dialog',
  standalone: true,
  imports: [CommonModule, PrimeNGSharedModule],
  templateUrl: './session-warning-dialog.component.html',
  styleUrls: ['./session-warning-dialog.component.scss']
})
export class SessionWarningDialogComponent implements OnInit, OnDestroy {
  visible = false;
  showCancel = false; // Only show when > 5 minutes left
  private sub = new Subscription();

  constructor(private readonly session: SessionService) {}

  ngOnInit(): void {
    this.sub.add(
      this.session.showWarningDialog$.subscribe(v => {
        this.visible = v;
        if (v) {
          const expiryRaw = localStorage.getItem(SESSION_CONSTANTS.TOKEN_EXPIRY);
          const expiryAt = expiryRaw ? Number(expiryRaw) : NaN;
          const msLeft = Number.isFinite(expiryAt) ? Math.max(0, expiryAt - Date.now()) : 0;
          this.showCancel = msLeft > 5 * 60 * 1000; // > 5 minutes -> show Dismiss
        }
      })
    );
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }

  onRefresh(): void { this.session.confirmExtend(); }
  onDismiss(): void { this.session.hideWarningDialog(); }
}
